import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import { createParcelGraphic } from './LayerBuilder';

/**
 * Composable for managing soil analysis map display
 * Extracted from FarmMap.vue sampleZones watcher logic
 */
export function useSoilAnalysisLayer(mapState, clearAllLayerDrawedOnMap, smapSamplePathsLayer, farmerLayer, farmerLocationsLayer, farmerLabelLayer, taskLocationsLayer, taskLabelLayer, farmFieldsLayer, parcelLabelLayer, samplePathsLabelLayer) {
  // Create dedicated layers for soil analysis display  
  const soilAnalysisLayer = new GraphicsLayer();
  const soilAnalysisLabelLayer = new GraphicsLayer();
  
  // Array to track graphics for zoom extent calculation
  let locationToZoom = [];

  /**
   * Update soil analysis display based on new sample zones data
   * This is the exact logic from FarmMap.vue sampleZones watcher
   */
  function updateSoilAnalysisDisplay(newSampleZones, oldSampleZones) {
    if (newSampleZones === oldSampleZones) return;
    
    // Always clear existing soil analysis graphics first to prevent color conflicts
    clearSoilAnalysisDisplay();
    
    if (newSampleZones && newSampleZones.length > 0) {
      // Preserve farm/farmer location layers along with sample paths and parcels
      const layersToPreserve = [
        smapSamplePathsLayer,
        farmerLayer,
        farmerLocationsLayer, 
        farmerLabelLayer,
        taskLocationsLayer,
        taskLabelLayer,
        farmFieldsLayer,
        parcelLabelLayer
      ].filter(layer => layer); // Filter out any undefined layers
      
      clearAllLayerDrawedOnMap(layersToPreserve);
      locationToZoom = [];
      
      
      
      // 1. show the polygons (parcels)
      newSampleZones.forEach(function (zone) {
        if (zone?.parcels) {
          JSON.parse(zone.parcels).forEach(function (parcel) {
            if (parcel.boundaries) {
              // Create a polygon geometry
              const { polygonGraphic, sampleLabel } = createParcelGraphic(parcel);
              locationToZoom.push(polygonGraphic);

              soilAnalysisLayer.add(polygonGraphic);
              samplePathsLabelLayer.add(sampleLabel);
            }
          });
        }
      });

      if (locationToZoom.length > 0 && mapState.view) {
        let options = {
          duration: 1000,
        };
        mapState.view.goTo(locationToZoom, options).catch(function (error) {
          
        });
      }
    } else {
      // If no sample zones, also preserve location layers
      const layersToPreserve = [
        smapSamplePathsLayer,
        farmerLayer,
        farmerLocationsLayer, 
        farmerLabelLayer,
        taskLocationsLayer,
        taskLabelLayer
      ].filter(layer => layer);
      
      clearAllLayerDrawedOnMap(layersToPreserve);
    }
  }

  /**
   * Clear all soil analysis graphics
   */
  function clearSoilAnalysisDisplay() {
    soilAnalysisLayer.removeAll();
    soilAnalysisLabelLayer.removeAll();
    // Also clear sample labels from sample paths label layer
    samplePathsLabelLayer.removeAll();
    locationToZoom = [];
  }

  return {
    soilAnalysisLayer,
    soilAnalysisLabelLayer,
    updateSoilAnalysisDisplay,
    clearSoilAnalysisDisplay
  };
}